import React from 'react'

export default function JobApply (){

    return(
        <div>
            JOb Apply Page
        </div>
    )
}